<template>
  <b-row v-if="items && items.length">
    <template v-for="(item, index) in items">
      <b-col
        v-if="allowed(item)"
        :key="index"
        :xl="courierDataApproved ? '3' : '12'"
        :lg="courierDataApproved ? '6' : '12'"
        class="mb-3"
      >
        <b-link :href="item.url" class="d-block h-100 inherited-link">
          <b-card class="mb-0 h-100" no-body>
            <b-card-body
              class="p-4 text-center d-flex"
              :class="{ 'px-md-5': !courierDataApproved, 'text-md-left': $dir.ltr, 'text-md-right': $dir.rtl }"
            >
              <b-row class="align-items-center">
                <b-col v-if="item.icon" cols="auto">
                  <font-awesome-icon
                    :icon="item.icon"
                    class="align-middle display-4 text-primary"
                  />
                </b-col>

                <b-col v-if="item.title || item.approvable">
                  <div :class="{ 'pl-md-2': $dir.ltr, 'pr-md-2': $dir.rtl }">
                    <h5 v-if="item.title" class="mb-0 font-weight-normal">
                      {{ $t(item.title) }}
                    </h5>

                    <div v-if="item.approvable" class="text-dark mt-3">
                      <span class="text-muted">
                        {{ $t('shared.status') }} :
                      </span>

                      <font-awesome-icon
                        :icon="getStatus(item) ? 'check-circle' : 'times-circle'"
                        class="align-middle mx-1"
                        :class="`text-${getStatus(item) ? 'success' : 'danger'}`"
                      />

                      {{ getStatus(item) ? $t('shared.approved') : $t('shared.notApproved') }}
                    </div>

                    <div v-if="!courierDataApproved" class="text-dark mt-3">
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        class="align-middle text-muted"
                        :class="{ 'mr-1': $dir.ltr, 'ml-1': $dir.rtl }"
                      />

                      {{ $t('couriers.clickHereForFillBasicInfo') }}.
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-link>
      </b-col>
    </template>
  </b-row>
</template>

<script>
  export default {
    name: 'ProfileButtons',
    data () {
      return {
        items: [
          {
            key: 'basicData',
            title: 'couriers.basicData.basicData',
            url: '/account/profile/basic-info',
            icon: 'user',
            statuses: ['emailConfirmed', 'phoneNumberConfirmed'],
            approvable: true
          },
          {
            key: 'signatories',
            title: 'couriers.signatories.signatories',
            url: '/account/profile/signatories',
            icon: 'signature',
            statuses: ['emailConfirmed', 'phoneNumberConfirmed', 'courierDataApproved'],
            approvable: false
          },
          {
            key: 'bankAccounts',
            title: 'couriers.bankAccounts.bankAccounts',
            url: '/account/profile/bank-accounts',
            icon: 'money-check-alt',
            statuses: ['emailConfirmed', 'phoneNumberConfirmed', 'courierDataApproved'],
            approvable: false
          },
          {
            key: 'contacts',
            title: 'couriers.contacts.contacts',
            url: '/account/profile/contacts',
            icon: 'address-book',
            statuses: ['emailConfirmed', 'phoneNumberConfirmed', 'courierDataApproved'],
            approvable: false
          }
        ]
      }
    },
    computed: {
      userStatus () {
        return this.$store.state.$userStatus
      },
      courierDataApproved () {
        return this.userStatus && this.userStatus.courierDataApproved
      }
    },
    methods: {
      allowed (item) {
        return this.$api.account.checkRolesAndStatuses(item)
      },
      getStatus (item) {
        switch (item.key) {
          case 'basicData':
            return this.courierDataApproved
        }
      }
    }
  }
</script>
